import {USER_DATA} from '@/shared/constants.js'
import {getUser, updateUser, getUserList, enableUser, getPermissions} from '@/services/user/index'
import {app} from '@/main'
import _set from "lodash/set";
import _get from "lodash/get";
import router from '@/router/index'
import routeName from '@/router/routeNames'
import {REFRESH_TOKEN, TOKEN, TOKEN_EXPIRES} from "@/shared/constants";

const state = {
  userData: {
    id: null,
    email: null,
    client_id: null,
    client: null,
    name: null,
    password:null,
    last_login:'',
    role: localStorage.getItem(USER_DATA) ? JSON.parse(localStorage.getItem(USER_DATA)).role : null
  },
  permissions: localStorage.getItem('permissions') ? localStorage.getItem('permissions') : [],
  search: {
    list: {
      list_count: 0,
      list_items: []
    },
    filter: {
      page: 1,
      limit: 20,
      name: '',
      client_id: null,
      email: '',
    }
  },

  timeout: null,
  max_inactivity:80
}

const mutations = {
  setUser(state, payload) {
    state.userData = payload
    localStorage.setItem(USER_DATA, JSON.stringify(payload))
    localStorage.setItem('language', payload.preferred_language)
    app.$i18n.locale = payload.preferred_language ? payload.preferred_language : 'bs'
  },

  setUserItem(state, payload) {
    _set(state, payload.path, payload.value)
  },
  setSearchListCount(state, count) {
    state.search.list.list_count = count
  },
  setSearchFilterItem(state, {item, value}) {
    state.search.filter[item] = value
  },
  setSearchList(state, list) {
    state.search.list.list_items = list
  },
  resetTimeout(state) {

    if (state.timeout !== null) {
      clearTimeout(state.timeout)
    }

    if (router.currentRoute.name !== routeName.RN_LOGIN && state.userData.max_inactivity !== null && state.userData.max_inactivity > 0) {
      state.timeout = setTimeout(() => {
        localStorage.clear();
        router.replace({name: routeName.RN_LOGIN, query: {redirect: router.currentRoute.fullPath}})
      }, state.userData.max_inactivity * 60000);
    }

  }
}

const getters = {
  getUser: function (state) {
    return state.userData
  },
  getUserRole(state){
    return state.userData.role
  },
  getUserItem(state) {
    return payload => _get(state, payload, null)
  },
  getSearchFilter(state) {
    return state.search.filter
  },
  getSearchList(state) {
    return state.search.list.list_items
  },
  getSearchListCount(state) {
    return state.search.list.list_count
  },
  getPermission: function (state) {
    return permission_id => state.permissions.includes(permission_id)
  },
  currentLanguage(state) {
    return state.userData && state.userData.preferred_language ? state.userData.preferred_language : 'bs';
  }

}

const actions = {
  actionSetUser({commit}) {
    return new Promise((resolve, reject) => {
      if (localStorage.getItem(USER_DATA) && localStorage.getItem(USER_DATA) !== '') {
        const user = JSON.parse(localStorage.getItem(USER_DATA))
        commit('setUser', user)
        commit('resetTimeout')
        resolve(user);
      } else {
        getUser().then(response => {
          commit('setUser', response.data)
          commit('resetTimeout')
          resolve(response.data);
        }, error => {
          reject(error);
        })
      }
    })
  },

  actionUpdateUser({commit}, {id, data}) {
    return new Promise((resolve, reject) => {
      updateUser(id, data).then(response => {
        commit('setUser', response.data)
        resolve(response);
      }, error => {
        reject(error);
      })
    })
  },
  actionSetUserItem({commit}, payload) {
    commit('setUserItem', payload)
  },
  actionSearch({commit, state}) {
    return new Promise((resolve, reject) => {
      getUserList(state.search.filter)
        .then((response) => {
          if(response.data) {
            commit('setSearchList', response.data.items || [])
            commit('setSearchListCount', response.data.total || 0)
          } else {
            commit('setSearchList', [])
            commit('setSearchListCount', 0)
          }

          resolve(response)
        }).catch(error => {
        reject(error)
      })
    })
  },
  actionSetUserPermissions({commit}) {
    return new Promise((resolve, reject) => {
      getPermissions().then(response => {
        let result = response.data.map(item => item.id)

        commit('setUserItem', {path: 'permissions', value: result})
        localStorage.setItem('permissions', JSON.stringify(result))
        resolve(response);
      }, error => {
        reject(error);
      })
    })
  },
  resetTimeout(state){
    if (state.timeout !== null) {
      clearTimeout(state.timeout)
    }

    if (router.currentRoute.name !== routeName.RN_LOGIN && state.userData.max_inactivity !== null && state.userData.max_inactivity > 0) {
      state.timeout = setTimeout(() => {
        localStorage.clear();
        router.replace({name: routeName.RN_LOGIN, query: {redirect: router.currentRoute.fullPath}})
      }, state.userData.max_inactivity * 60000);
    }

}
}

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced: true
}
